/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {McPaginatedTabHeader as ɵh} from './paginated-tab-header';
export {McTabLabelWrapperBase as ɵa,McTabLabelWrapperMixinBase as ɵb} from './tab-label-wrapper.directive';
export {MC_TAB_LABEL as ɵe} from './tab-label.directive';
export {McTabLinkBase as ɵf,McTabLinkMixinBase as ɵg} from './tab-nav-bar/tab-nav-bar';
export {McTabBase as ɵc,McTabMixinBase as ɵd} from './tab.component';